import { type WebviewJavascriptBridgeApi } from '../type.api.js';
import { awaitNtvPluginReady } from './await-ntv-plugin-ready.js';
import { ntvHasMethod } from './builtin-ntv.js';
import { call } from './call.js';
import { registerAsync, registerSync, webIsReady } from './register.js';

/**
 * 导出(WebViewJavascriptBridge) Api named `fabric`
 */
export const fabric: WebviewJavascriptBridgeApi = {
  call,
  webIsReady,
  registerSync,
  registerAsync,
  ntvHasMethod,
  awaitNtvPluginReady,
  // Don't need to provider this api for ios now
  // ntvDisableJavascriptDialogBlock,
};
